export const hasAuthToken = (): boolean => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return false;
  }

  try {
    // Check for custom storage key used by Supabase client
    const customToken = localStorage.getItem('medipaths-auth-token');
    if (customToken) {
      return true;
    }

    // Fallback to default Supabase keys for compatibility
    return Object.keys(localStorage).some(
      key => key.startsWith('sb-') && key.includes('-auth-token')
    );
  } catch {
    return false;
  }
};
